(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-timer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Country ISO to phone code mapping
    const countryToPhoneCode = {
      'QA': '+974', 'SA': '+966', 'AE': '+971', 'US': '+1', 'GB': '+44',
      'AU': '+61', 'FR': '+33', 'DE': '+49', 'IT': '+39', 'ES': '+34',
      'JP': '+81', 'CN': '+86', 'IN': '+91', 'MX': '+52', 'BR': '+55',
      'RU': '+7', 'KR': '+82', 'ZA': '+27', 'NZ': '+64', 'NL': '+31',
      'SE': '+46', 'NO': '+47', 'DK': '+45', 'FI': '+358', 'PL': '+48',
      'PT': '+351', 'CH': '+41', 'AT': '+43', 'BE': '+32', 'IE': '+353',
      'SG': '+65', 'HK': '+852', 'CA': '+1'
    };

    const phoneForms = document.querySelectorAll('.phone-form');

    phoneForms.forEach(function (form) {
      const button = form.querySelector('.phone-form__button');
      const buttonText = form.querySelector('.phone-form__button-text');
      const buttonLoader = form.querySelector('.phone-form__button-loader');
      const countrySelect = form.querySelector('.phone-form__country-select');
      const phoneInput = form.querySelector('.phone-form__input');
      const wrapper = form.closest('.phone-form-wrapper');
      const modal = wrapper ? wrapper.querySelector('.phone-form__modal') : null;
      const modalClose = modal ? modal.querySelector('.phone-form__modal-close') : null;

      // Auto-select country based on Shopify's localization
      if (countrySelect && window.Shopify && window.Shopify.country) {
        const userCountryCode = window.Shopify.country;
        const phoneCode = countryToPhoneCode[userCountryCode];

        if (phoneCode) {
          // Find and select the matching option
          const options = countrySelect.querySelectorAll('option');
          options.forEach(function(option) {
            if (option.value === phoneCode) {
              option.selected = true;
            }
          });
        }
      }

      if (form && button && countrySelect && phoneInput && modal) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();

          const countryCode = countrySelect.value;
          const phoneNumber = phoneInput.value;
          const fullPhoneNumber = countryCode + phoneNumber;
          const referee = window.location.origin;
          const apiEndpoint = form.dataset.apiEndpoint;

          // Validate API endpoint
          if (!apiEndpoint || apiEndpoint.trim() === '') {
            alert('API endpoint is not configured. Please set it in the theme editor.');
            return;
          }

          // Show loader
          button.disabled = true;
          buttonText.style.display = 'none';
          buttonLoader.style.display = 'inline-block';

          // POST to configured API endpoint
          fetch(apiEndpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              phone: fullPhoneNumber,
              referee: referee,
            }),
          })
            .then(function (response) {
              return response.json();
            })
            .then(function (data) {
              console.log('Success:', data);
              console.log('Submitted - Phone:', fullPhoneNumber, 'Referee:', referee);

              // Hide loader
              button.disabled = false;
              buttonText.style.display = 'inline-block';
              buttonLoader.style.display = 'none';

              // Clear form
              form.reset();

              // Show modal
              modal.style.display = 'flex';
            })
            .catch(function (error) {
              console.error('Error:', error);

              // Hide loader
              button.disabled = false;
              buttonText.style.display = 'inline-block';
              buttonLoader.style.display = 'none';

              alert('Something went wrong. Please try again.');
            });
        });

        // Close modal
        if (modalClose) {
          modalClose.addEventListener('click', function () {
            modal.style.display = 'none';
          });
        }

        // Close modal on outside click
        if (modal) {
          modal.addEventListener('click', function (e) {
            if (e.target === modal) {
              modal.style.display = 'none';
            }
          });
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
